<template>
  <div v-if="dataNAFBrakeDown">
    <div class="card has-border">
      <div class="card-header pt-1 pb-1">NAF Breakdown</div>
      <div class="card-body">
        <dl
          class="row mb-0"
          v-for="(obj, index) in dataNAFBrakeDown"
          :key="index"
        >
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">{{ obj.name }}</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ obj.value | with-decimal }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WDDashboardNAFBrakeDown',
  props: ['dataNAFBrakeDown']
}
</script>
<style scoped>
.card.has-border {
  border: 1px solid;
}
</style>
